import React, {Component} from 'react';
import AddPositionLoanableView from "./AddPositionLoanableView";
import {Growl} from "primereact/growl";
import {ADD_INSTRUMENT_ROUTE, ADD_POSITION_LOANABLE_ROUTE} from "../../../../utils/constants/RoutesConstants";
import {validateNumberIntegersDecimals} from "../../../../utils/formatters/Numbers";
import {CatalogDateService} from "../../../../service/catalog/CatalogDateService";
import {RestrictionsService} from "../../../../service/ptm/RestrictionsService";
import {CaptureLoanableValuesService} from "../../../../service/ptm/CaptureLoanableValuesService";
import {Button} from "primereact/button";
import {calculateRewardContainer, withoutComma} from "../../../../utils/calculate/Amount";


export default class AddPositionLoanableContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * Se toma el elemento a editar que viene de la pantalla anterior.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     *              Trae el elemento de la pantalla anterior para editar.
     */
    constructor(props) {
        super(props);
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        this.catalogDateService = new CatalogDateService();
        this.restrictionsService = new RestrictionsService();
        this.captureLoanableValuesService = new CaptureLoanableValuesService();
        this.accountDropDown = React.createRef();
        this.getMaxValueDate = this.getMaxValueDate.bind(this);
        this.getRestrictions = this.getRestrictions.bind(this);

        this.state = {
            returnPath: this.props.location.state.returnPath,
            positionData: {
                accountObj: {},
                instrumentObj: {},
                idEmisora: '',
                cuenta: '',
                cantidad: '',
                tasa: '',
                sobreTasa: '0',
                plazo: '',
                fechaVence: '',
                validDate: true,
                precio: '',
                copyPrice: '',
                premioMin: '0',
                total: '',
                premio: '',
                fecValor: today,
                vigencia: 'D',
                valuesAccepted: '',
                restricciones: 'TODOS',
                dateObj: today,
                today: today,
                maxValueDate: this.getMaxValueDate(),
                banderaOtc: false,
                disabledRadio: false,
            },
            restrictionsPosture: [],
            listRestrictions: this.getRestrictions(),
            displayDialog: false,
            isLoading: false,
        };

        this.onChangeText = this.onChangeText.bind(this);
        this.onChangeDropDown = this.onChangeDropDown.bind(this);
        this.onChangeRadio = this.onChangeRadio.bind(this);
        this.onChangeRestrictions = this.onChangeRestrictions.bind(this);
        this.getExpirationDate = this.getExpirationDate.bind(this);
        this.addPosition = this.addPosition.bind(this);
        this.validateRequiredFields = this.validateRequiredFields.bind(this);
        this.getErrors = this.getErrors.bind(this);
        this.returnCaptureValuesPage = this.returnCaptureValuesPage.bind(this);
        this.redirectAddInstrument = this.redirectAddInstrument.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.modifyRestrictions = this.modifyRestrictions.bind(this);
        this.openRestrictionsDialog = this.openRestrictionsDialog.bind(this);
        this.loading = this.loading.bind(this);
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    getMaxValueDate() {
        this.loading(true);
        this.catalogDateService.getMaxValueDate().then(
            valueDate => {
                let positionDataAux = this.state.positionData;
                positionDataAux['maxValueDate'] = new Date(valueDate[0])
                this.setState({
                    positionData: positionDataAux,
                });
            });
        this.loading(false);
    }

    getRestrictions() {
        this.loading(true);
        this.restrictionsService.getRestrictions()
            .then(resp => {
                let restrictionsStr = '';
                let positionData = this.state.positionData;

                resp.payload.forEach(item => {
                    restrictionsStr = restrictionsStr.concat(', ' + item.nombre)
                });
                positionData['valuesAccepted'] = restrictionsStr.substring(1);
                this.setState({
                    listRestrictions: resp.payload,
                    restrictionsPosture: resp.payload,
                    positionData: positionData,
                });
            });
        this.loading(false);
    }

    getExpirationDate(positionData) {
        this.loading(true);
        let plazo = positionData.plazo ?
            positionData.plazo : this.state.positionData.plazo;
        let fecValor = positionData.fecValor ?
            positionData.fecValor : this.state.positionData.fecValor;
        this.catalogDateService.getMaturityDate(withoutComma(plazo.toString()), fecValor)
            .then(dateInfo => {
                let positionDataAux = this.state.positionData;
                positionDataAux['fechaVence'] = dateInfo[0];
                positionDataAux['validDate'] = dateInfo[1] === 1;
                this.setState({
                    positionData: positionDataAux
                });
            });
        this.loading(false);
    }

    onChangeRestrictions(event) {
        this.setState({restrictionsPosture: event.value});
    }

    /**
     * Función que maneja el cambio de valor en los campos de texto
     * y los coloca en el state dentro del objeto que se va a editar.
     * @param event Contiene el valor que fue modificado en la vista.
     */
    onChangeText(event) {
        let {name, value, id} = event.target;
        value = value ? value : '';
        let positionDataAux = this.state.positionData;
        positionDataAux[name] = value;
        let numValue = Number(withoutComma(value));

        if (name === "tasa" || name === "sobreTasa" || name === "premioMin") {
            positionDataAux[name] = validateNumberIntegersDecimals(numValue, id, 2);
        } else if (name === "plazo") {
            if (value !== '' && value !== '0') {
                this.getExpirationDate(positionDataAux)
            }
        } else if (name === "fecValor") {
            if (positionDataAux['plazo'] !== '' && positionDataAux['plazo'] !== '0') {
                this.getExpirationDate(positionDataAux);
            }
            if(value > this.state.positionData.today){
                positionDataAux['precio'] = '';
                positionDataAux['disabledRadio'] = true;
            }else{
                positionDataAux['disabledRadio'] = false;
                positionDataAux['precio'] = this.state.positionData.copyPrice;
            }
        }

        this.setState({positionData: positionDataAux,})
    }

    /**
     * Función que maneja el cambio en el dropdown de cuenta
     * se guarda la opción elegida en una variable del estado
     * @param event Evento que trae el valor que se eligió.
     */
    onChangeDropDown(event) {
        let {name, value} = event.target;
        value = value ? value : {};
        let positionDataAux = this.state.positionData;
        positionDataAux[name] = value;
        switch (name) {
            case "instrumentObj":
                positionDataAux['idEmisora'] = value.idEmisora ? value.idEmisora : '';
                positionDataAux['copyPrice'] = value.precio24 ? value.precio24.toFixed(6) : '';
                if(this.state.positionData.fecValor > this.state.positionData.today){
                    positionDataAux['precio'] = '';
                    positionDataAux['disabledRadio'] = true;
                }else{
                    positionDataAux['disabledRadio'] = false;
                    positionDataAux['precio'] = value.precio24 ? value.precio24.toFixed(6) : '';
                }
                break;
            case "accountObj":
                positionDataAux['cuenta'] = value.cuenta ? value.cuenta : '';
                break;
            default:
                break;
        }
        this.setState({positionData: positionDataAux,})
    }

    onChangeRadio(event) {
        let positionDataAux = this.state.positionData;
        positionDataAux['vigencia'] = event.value;
        this.setState({
            positionData: positionDataAux,
        });
    }

    /**
     * Función que consume a CaptureGuaranteesService para guardar los datos
     * del elemento nuevo.
     * Se hace una validación que estén presentes los datos obligatorios.
     */
    addPosition() {
        this.loading();
        let msgError = this.getErrors();
        if (msgError === '') {
            this.captureLoanableValuesService.addPosition(this.state.positionData)
                .then(resp => {
                    let message = {};

                    if (resp.message === 'Success') {
                        message = {
                            severity: 'success',
                            summary: 'Éxito',
                            detail: 'La postura se ha agregado correctamente',
                        };
                    } else if (resp.message !== '' && resp.message !== 'Success') {
                        message = {
                            severity: 'success',
                            summary: 'Éxito',
                            detail: resp.message.replace(/%/g, ''),
                        };
                    } else if (resp.error !== '') {
                        message = {
                            severity: 'error',
                            summary: 'Error.',
                            detail: resp.error.replace(/%/g, '')
                        };
                    }

                    this.returnCaptureValuesPage(message);
                });
        } else {
            this.growl.show({severity: 'error', summary: 'Error.', detail: msgError});
        }
    }

    validateRequiredFields() {
        let result = false;
        this.state.requiredFieldsList.forEach(field => {
            if (this.state.userData[field] === '') {
                result = true;
                return true;
            }
        });
        return result;
    }

    getErrors() {
        let msgError = '';
        let premio = calculateRewardContainer(
            this.state.positionData.cantidad,
            this.state.positionData.precio,
            this.state.positionData.tasa,
            this.state.positionData.plazo
        );

        if (this.state.positionData.idEmisora === '') {
            msgError = 'Seleccione la emisora a la que se agregó la solicitud';
        } else if (this.state.positionData.cuenta === '') {
            msgError = 'Seleccione la cuenta a la que se agregó la solicitud';
        } else if (this.state.positionData.cantidad === '' || this.state.positionData.cantidad === '0') {
            msgError = 'La cantidad no puede ser cero o vacía';
        } else if (this.state.positionData.plazo === '' || this.state.positionData.plazo === '0') {
            msgError = 'El plazo no puede ser cero o vacío';
        } else if (this.state.positionData.tasa === '') {
            msgError = 'La tasa no puede ser vacía';
        } else if ((this.state.positionData.plazo === '') || (!this.state.positionData.validDate)) {
            msgError = 'El Plazo es incorrecto ya que el vencimiento no puede ser sábado, domingo o en día festivo';
        } else if (Number(withoutComma(this.state.positionData.premioMin.toString())) >
            Number(withoutComma(premio))) {
            msgError = 'El premio mínimo debe ser menor al premio calculado';
        } else if (withoutComma(premio).length > 16) {
            msgError = 'Importe de Premio excede longitud le sugerimos revisar la tasa'
        }
        return msgError;
    }

    /**
     * Función que regresa a la pantalla de Captura de Garantías
     */
    returnCaptureValuesPage(message) {
        this.setState({isLoading: false,});
        this.props.history.push({
            pathname: this.state.returnPath,
            message: message,
        });
    }

    /**
     * Función que redirecciona a la pantalla de editar
     */
    redirectAddInstrument() {
        this.props.history.push({
            pathname: ADD_INSTRUMENT_ROUTE,
            state: {
                callScreen: 'orderLender',
                returnPath: ADD_POSITION_LOANABLE_ROUTE,
            },
        });
    }

    modifyRestrictions() {
        let restrictionsStr = '';
        let positionDataAux = this.state.positionData;
        let displayDialogAux = true;

        if (this.state.restrictionsPosture.length === 0) {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: 'Seleccionar al menos una restricción del portafolio default'
            });
        } else if (this.state.restrictionsPosture.length === this.state.listRestrictions.length) {
            this.state.restrictionsPosture.forEach(item => {
                restrictionsStr = restrictionsStr.concat(', ' + item.nombre)
            });
            positionDataAux['restricciones'] = 'TODOS';
            positionDataAux['valuesAccepted'] = restrictionsStr.substring(1);
            displayDialogAux = false;
        } else {
            let restrictionsAux = ' ';
            this.state.restrictionsPosture.forEach(item => {
                restrictionsStr = restrictionsStr.concat(', ' + item.nombre);
                restrictionsAux = restrictionsAux.concat(',' + item.id + '|' + item.tipo);
            });
            positionDataAux['restricciones'] = restrictionsAux.substring(2);
            positionDataAux['valuesAccepted'] = restrictionsStr.substring(1);
            displayDialogAux = false;
        }
        this.setState({
            positionData: positionDataAux,
            displayDialog: displayDialogAux,
        });
    }

    onHideDialog() {
        this.setState({
            displayDialog: false,
        });
    }

    openRestrictionsDialog() {
        this.setState({
            displayDialog: true,
        });
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let dialogHeader = <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-6 p-lg-6">
                <h2 className={"secondary-text"}>Modificar restricciones</h2>
            </div>
            <div className="p-col-12 p-md-3 p-lg-3">
                <Button label="Regresar" onClick={this.onHideDialog}
                        className="p-button-secondary"/>
            </div>
            <div className="p-col-12 p-md-3 p-lg-3">
                <Button label="Guardar" onClick={this.modifyRestrictions}/>
            </div>
        </div>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {
            positionData, isLoading, restrictionsPosture,
            listRestrictions, displayDialog
        } = this.state

        return (
            <AddPositionLoanableView
                positionData={positionData}
                messagesGrowl={messagesGrowl}
                isLoading={isLoading}
                restrictionsPosture={restrictionsPosture}
                listRestrictions={listRestrictions}
                dialogHeader={dialogHeader}
                displayDialog={displayDialog}
                loading={this.loading}
                onChangeText={this.onChangeText}
                onChangeDropDown={this.onChangeDropDown}
                onChangeRestrictions={this.onChangeRestrictions}
                onChangeRadio={this.onChangeRadio}
                onHideDialog={this.onHideDialog}
                addPosition={this.addPosition}
                returnCaptureValuesPage={this.returnCaptureValuesPage}
                redirectAddInstrument={this.redirectAddInstrument}
                getExpirationDate={this.getExpirationDate}
                openRestrictionsDialog={this.openRestrictionsDialog}
            />
        );
    }
}
